module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-3-photo-10-af9b161abc857b79ce8f722d8f0457a1.webp";